export const SUCCESS_ATTRIBUTION_SUBMITTED = 'SUCCESS_ATTRIBUTION_SUBMITTED';

export const successAttributionSubmitted = () => dispatch =>
  dispatch({
    type: SUCCESS_ATTRIBUTION_SUBMITTED,
  });
